import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

const patientNamespace = { namespace: "patient" };
@Component({})
export default class ColorLimits extends Vue {
  @Getter("displayVarLevels", patientNamespace)
  displayVarLevels!: Array<any>;

  @Getter("mobileDisplayVarLevels", patientNamespace)
  mobileDisplayVarLevels!: Array<any>;

  tableColors = [
    "tableRed",
    "tableYellow",
    "tableGreen",
    "tableYellow",
    "tableRed"
  ];

  get iterableLevels() {
    if (this.mobileDisplayVarLevels) {
      const flattenedLevels: Array<any> = [];
      let lastCat = "";
      this.mobileDisplayVarLevels
        .map((a: any) => {
          return {
            category: a.category,
            title: a.title,
            levels: a.levels,
            unit: a.unit
          };
        })
        .sort((n1: any, n2: any) =>
          n1.category > n2.category
            ? 1
            : n1.category < n2.category
            ? -1
            : n1.category === n2.category && n1.title > n2.title
            ? 1
            : -1
        )
        .forEach((e: any) => {
          if (lastCat != e.category) {
            flattenedLevels.push({
              category: e.category,
              isHeader: true
            });
            lastCat = e.category;
          }
          flattenedLevels.push(e);
        });
      return flattenedLevels;
    } else return false;
  }
}
